<ng-template #verificareConsangvinizare let-modal="close">
  <div class="modal-header">
    <h3 class="modal-title">
      Verificare Consangvinizare
    </h3>

    <button
      type="button"
      class="close"
      aria-hidden="true"
      (click)="modal('Cross click')"
    >
      ×
    </button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">

      <form [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <div class="form-group mb-3">
              <label for="taur">
                Matricol taur
              </label>

              <input
                type="text"
                id="taur"
                formControlName="taur"
                class="form-control w12"
                (input)="
                  form.patchValue({
                    taur: $event.target.value.toUpperCase()
                  })
                "
              />
            </div>
          </div>
        </div>

        <div class="row mt-1">
          <div class="col-12">
            <label>
              Femele din exploatația:
            </label>

            <br>
            <span class="h5">{{ numeExploatatie }} - {{ codExploatatie }}</span>
          </div>
        </div>

        <div
          *ngIf="loadingSpinner"
          class="spinner-border text-info avatar-lg"
          role="status"
        ></div>

        <div
          *ngIf="!loadingSpinner"
          class="row mt-3"
        >
          <div class="col-12">
            <button
              class="btn btn-blue"
              (click)="submitVerificare()"
            >
              Verifică
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>
</ng-template>
